import React, { useState, memo } from "react";
import { Modal, Button, Tooltip } from "antd";
import PDF from "./SoftwareLicenseAgreementAlpaca.pdf";
import packageJson from "../../../../../../package.json";
import { Viewer, Worker } from "@react-pdf-viewer/core";
const pdfjsVersion = packageJson.dependencies["pdfjs-dist"];

const PDFViewer = memo(({ file, workerSrc }) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Worker workerUrl={workerSrc}>
        <Viewer fileUrl={file} />
      </Worker>
    </div>
  );
});

const TermsAndConditions = ({
  open = false,
  onReject = () => {},
  onConfirm = () => {},
}) => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleScroll = (e) => {
    const target = e.currentTarget;

    const { scrollTop, scrollHeight, clientHeight } = target;

    // Allow a 1px leeway for rounding issues
    const isBottom = scrollTop + clientHeight >= scrollHeight - 220;
    // if (isBottom && isAtBottom !== isBottom) {
    //
    console.log("set");
    setIsAtBottom(isBottom);
    // }
  };

  return (
    <>
      <Modal
        open={open}
        closable={false}
        footer={
          <>
            <Button onClick={onReject} style={{ marginRight: ".5rem" }}>
              Exit
            </Button>
            <Tooltip
              title={
                "Please scroll to the bottom of the Terms & Conditions to enable this button"
              }
            >
              <Button onClick={onConfirm} disabled={!isAtBottom}>
                Agree to Terms & Conditions
              </Button>
            </Tooltip>
          </>
        }
        width={"60vw"}
      >
        <div
          onScroll={(e) => handleScroll(e)}
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            border: "1px solid #eee",
            paddingRight: 8,
          }}
        >
          <PDFViewer
            file={PDF}
            workerSrc={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}
          />
        </div>
      </Modal>
    </>
  );
};

export default TermsAndConditions;
